module.exports = "https://static.wmbcdn.com/uniweb/images/9ce4346915452c92caef72c6b460b7f3.svg";